import { html, css, LitElement } from 'lit';

class ToggleSwitch extends LitElement {
  static get properties() {
    return {
      on: { type: Boolean },
      title: { type: String },
      leftText: { type: String },
    };
  }

  constructor() {
    super();
    this.on = true;
    this.title = '';
    this.leftText = '';
  }

  static get styles() {
    return css`
      :host {
        --background-color: var(--toggle-color, green);
      }

      .toggle-switch-container {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .left-text {
        color: #2E2E3A;
        font-family: Outfit;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 12px;
        letter-spacing: -0.14px;
      }

      .toggle-switch {
        position: relative;
        display: inline-block;
        width: 44px;
        height: 24px;
        border-radius: 24px;
        background-color: #EFF1F7;
        transition: background-color 0.3s ease;
        cursor: pointer;
      }

      .toggle-switch::before {
        content: '';
        position: absolute;
        top: 3px;
        left: 3px;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background-color: white;
        transition: transform 0.3s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      }

      .toggle-switch.on {
        background-color: var(--background-color);
      }

      .toggle-switch.on::before {
        transform: translateX(20px);
      }

      .title {
        color: #2E2E3A;
        font-family: Outfit;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 12px;
        letter-spacing: -0.14px;
      }
    `;
  }

  render() {
    return html`
      <div class="toggle-switch-container">
        ${this.leftText ? html`<span class="left-text">${this.leftText}</span>` : ''}
        <div
          class="toggle-switch ${this.on ? 'on' : ''}"
          @click="${this.toggleSwitch}"
        ></div>
        <span class="title">${this.title}</span>
      </div>
    `;
  }

  toggleSwitch() {
    this.on = !this.on;
    this.dispatchEvent(new CustomEvent('switch-toggled', { bubbles: true, composed: true, detail: this.on }));
  }
}

customElements.define('toggle-switch-element', ToggleSwitch);
